import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import SelectDropDown from '../../../../components/elements/SelectDropDown'
import InputCustom from '../../../../components/elements/InputCustom'
import TextAreaCustom from '../../../../components/elements/TextAreaCustom'
import ProductDescription from './ProductDescription'
import ProductFiles from './ProductFiles'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { loadCategories, loadSubCategoriesByCategory } from '../../../../store/Actions/ActionCategory'
import { loadWarehouses } from '../../../../store/Actions/ActionWarehouses'
import { postProduct } from '../../../../store/Actions/ActionProducts'
import { VariableProducts } from '../VariablesProducts'

function AddProduct() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { categories, sub_categories_by_category,warehouses } = useSelectorCustom()
    const { state, setStateCustom, setLoad } = VariableProducts();
    const [optionCategories, setOptionCategories] = useState([])
    const [optionSubCategories, setOptionSubCategories] = useState([])
    const [optionWarehouse, setOptionWarehouse] = useState([])
    const { translate } = AbstructLang()
    const [fields, setFields] = useState([{ name: '', description: '' }])
    const [fields1, setFields1] = useState([{ file_path: '', notes: '' }])
    useEffect(() => {
        dispatch(loadCategories())
        dispatch(loadWarehouses())
    }, []);
    useEffect(() => {
        setOptionCategories(categories?.map((category) => ({
            value: category?.id,
            label: category?.name
        })))
    }, [categories]);
    useEffect(() => {
        setOptionWarehouse(warehouses?.map((warehouse) => ({
            value: warehouse?.id,
            label: warehouse?.name
        })))
    }, [warehouses]);
    useEffect(() => {
        if (state.material_category_id !== '') {
            dispatch(loadSubCategoriesByCategory(state.material_category_id))
        }
    }, [state.material_category_id]);
    useEffect(() => {
        setOptionSubCategories(sub_categories_by_category?.map((i) => ({
            value: i.id,
            label: i.name
        })))
    }, [sub_categories_by_category]);
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postProduct(state,fields1,fields, setLoad));
    };
    return (
        <>
            {/*<main>
                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"}>*/}
            <div className='inner-main' >
                <h3>{translate('add_product')}</h3>
                <p className='basic-pro' >{translate('basic_product_info')}</p>
                <div className='d-flex'>
                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                        <span>{translate('category')}</span>
                        <SelectDropDown
                            options={optionCategories}
                            varr={state.material_category_id}
                            setVarr={(value) => setStateCustom('material_category_id', value)}
                        />
                    </div>
                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                        <span>{translate('sub_categories')}</span>
                        <SelectDropDown
                            options={optionSubCategories}
                            varr={state.material_sub_category_id}
                            setVarr={(value) => setStateCustom('material_sub_category_id', value)}
                        />
                    </div>
                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                        <span>{translate('warehouse')}</span>
                        <SelectDropDown
                            options={optionWarehouse}
                            varr={state.warehouse_id}
                            setVarr={(value) => setStateCustom('warehouse_id', value)}
                        />
                    </div>
                    <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                        <span>{translate('status')}</span>
                        <SelectDropDown
                            options={[{ value: 'active', label: "active" }, { value: 'unactive', label: "unactive" }]}
                            varr={state.status}
                            setVarr={(value) => setStateCustom('status', value)}
                        />
                    </div>
                </div>
                <div className='d-flex' style={{ marginTop: '10px' }} >
                    <InputCustom
                        label='name'
                        iconType='pencil'
                        type='text'
                        onChange={(e) => setStateCustom('name', e.target.value)}
                    />
                    <InputCustom
                        label='type'
                        iconType='pencil'
                        type='text'
                        onChange={(e) => setStateCustom('type', e.target.value)}
                    />
                    <InputCustom
                        label='brand'
                        iconType='pencil'
                        type='text'
                        onChange={(e) => setStateCustom('brand', e.target.value)}
                    />
                    <InputCustom
                        label='model'
                        iconType='pencil'
                        type='text'
                        onChange={(e) => setStateCustom('model', e.target.value)}
                    />
                    <InputCustom
                        label='serial_number'
                        iconType='pencil'
                        type='number'
                        onChange={(e) => setStateCustom('sn', e.target.value)}
                    />

                </div>
                <div className='d-flex' style={{ marginTop: '-10px' }} >
                    <div style={{width: '555px'}} >
                        <TextAreaCustom
                            label='notes'
                            onChange={(e) => setStateCustom('notes', e.target.value)}
                            nameClass='textarea-general'
                        />
                    </div>
                    <div style={{width: '555px'}} >
                        <TextAreaCustom
                            label='description'
                            onChange={(e) => setStateCustom('description', e.target.value)}
                            nameClass='textarea-general'
                        />
                    </div>
                </div>
                <ProductDescription fields={fields} setFields={setFields} />
                <ProductFiles title={translate('material_files')} fields={fields1} setFields={setFields1} />
                {/*<ProductSupplier fields={fields2} setFields={setFields2}  />*/}
                <div style={{ marginTop: "20px" }} >
                    <button onClick={handleSubmit} className='btn_top_table' >
                        {
                            state.Load? "Loading ..." : translate('save')
                        }
                    </button>
                </div>
            </div>
            {/*</div>
            </main>*/}
        </>
    )
}

export default AddProduct